import axios from "axios"
import useSWR from "swr"
import nProgress from "nprogress"
import toast from "react-hot-toast"
import { lang } from "config"


export const executeAPI = async (base_url, api_name, params, onSuccess, onError) => {  
        
    const  onResult = async (result) => {
        const access_token = localStorage.getItem('access_token') ?? ''

        if (result?.is_token_expired === true) {
            //toast.success('refresh_token')
            await sendAxios(base_url, 'refresh_token', {bloomreef_id: process.env.REACT_APP_BLOOMREEF_ID, access_token: access_token}, false)
        } else if (result?.is_new_token === true) {
            await sendAxios(base_url, api_name, params, false)
        } else if (result?.is_error === false) {
            onSuccess(result?.data, result?.message)
        } else {
            onError(result?.message)
        }
    }

    const sendAxios = async (base_url, api_name, params) => {
        const access_token = localStorage.getItem('access_token') ?? null;
        let data
        let message
        let is_error = false;
        let is_token_expired = false;
        let is_new_token = false;

        //toast.success("API: " + 'access_token: ' + access_token);

        nProgress.start()
        axios.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded';
        await axios({method: 'post', url: `${base_url}/${api_name}` , 
        data: params, 
        headers: {}
        }).then((response) => {
            if (response.data.success === 1) {
                is_error = false;
                if (response.data.message === "New token") {
                    is_new_token = true;
                    localStorage.removeItem('access_token');
                    localStorage.setItem('access_token', response.data.data.token);
                    //toast.success("API: " + 'new token ' + response.data.data.token);
                    message = response.data.data.token
                } else {
                    data = response.data
                    message = response.data.message
                    //toast.success("API: " + JSON.stringify(data));
                }
            } else {
                is_error = true;
                if (response.data.message === "Expired token") {
                    is_token_expired = true;
                }
                //toast.success("API: " + (response.data.message ?? lang.something_wrong))
                message = response.data.message ?? lang.something_wrong
            }
            nProgress.done()
            onResult({data, message, is_error, is_token_expired, is_new_token});
        }).catch((error) => {
            is_error = true;
            //toast.success("API: " + `${error.message} - ${error.response.data}`)
            message = `${error.message} - ${error?.response?.data ?? ''}`
            nProgress.done()
            onResult({data, message, is_error, is_token_expired, is_new_token});
        })
    }
    
    await sendAxios(base_url, api_name, params)
}

const fetcher = async (url, params, access_token) => {
    return await axios({method: 'get', url: url, params: params,
        headers: 
        {
            'Authorization': `Bearer ${access_token}` 
        }}).then(res => res.data)
}

const GetResultSet = (base_url, api_name, params) => {
    var access_token = localStorage.getItem('access_token') ?? ''
    // console.log("SWR access_token: ", access_token)
    //toast.success("SWR access_token: " + access_token)
    //toast.success("GetResultSet api name: " + base_url + '/' + api_name)
    const { data, error, mutate, isValidating } = useSWR([`${base_url}/${api_name}`, params, access_token], fetcher)
  
    // console.log("SWR data.message: ", data?.message)
    //toast.success("SWR data.message: " + data?.message)

    // if (access_token === '') {
    //     axios.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded';
    //     axios({method: 'post', url: `${base_url}/get_token`, 
    //     data:  {bloomreef_id: process.env.REACT_APP_BLOOMREEF_ID, 
    //         bloomreef_key: process.env.REACT_APP_BLOOMREEF_KEY}}).then((response) => {
    //         if (response.data.success === 1) {
    //             if (response.data.message === "New token") {
    //                 access_token = response.data.data.token
    //                 localStorage.removeItem('access_token');
    //                 localStorage.setItem('access_token', response.data.data.token);
    //             }
    //             mutate()
    //         }
    //     })
    // }  
    if (data?.message === "Expired token") {
        //toast.success("SWR initiate refresh_token")
        axios.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded';
        axios({method: 'post', url: `${base_url}/refresh_token`, 
        data:  {bloomreef_id: process.env.REACT_APP_BLOOMREEF_ID, access_token: access_token}, 
        headers: {'Authorization': `Bearer ${access_token}`}}).then((response) => {
            if (response.data.success === 1) {
                //toast.success("SWR refresh_token success")
                if (response.data.message === "New token") {
                    access_token = response.data.data.token
                    localStorage.removeItem('access_token');
                    localStorage.setItem('access_token', response.data.data.token);
                }
                mutate()
            }
        })
    }

    // console.log("SWR data: ", data)

    return {
        data,
        isLoading: !error && !data,
        error,
        isValidating,
        mutate
    }
}

export const useResultSet = (base_url, api_name, params) => {
    const { data, error, mutate, isValidating } = GetResultSet(base_url, api_name, params) 

    return {
        data,
        isLoading: !error && !data,
        error,
        isValidating,
        mutate
    }
}
